<template>
    <div class="form-group">
        <label></label>
        <span>{{$translate.text('general.original') + ': ' + placeholder}}</span>
    </div>
</template>

<script>
export default {
    name: 'Placeholder',

    props: {
        placeholder: {
            type: String,
            default: '',
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.form-group {
   display: flex;
   align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    span {
        flex: 6;
        padding: 0px 16px;
        font-size: 12px;
        font-style: italic;
        color: $blue-light;
    }
}
</style>
